import { debounce, checkMobileOrDesktopHeader } from './helper';

const sidebar = document.querySelector('#sidebar');
let header = checkMobileOrDesktopHeader();
let observer;

const changeNavColorOnScroll = debounce(() => {
  header = checkMobileOrDesktopHeader();
  observer.observe(header);
}, 200);

if (sidebar) {
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sidebar.classList.add('translate-x-full');
      } else {
        sidebar.classList.remove('translate-x-full');
      }
    });
  }, { threshold: 0.33 });
  changeNavColorOnScroll();
  window.addEventListener('resize', changeNavColorOnScroll);
}
